import React, { useState, useEffect } from "react";
import { Table, Spin, message, Button, Space } from "antd";
import { fetchSubjects, deleteSubject } from "../../ApiServices/getSubjectService";
import { getSubjectTableColumns } from "../../Config/subjectTableColumns";
import CreateSubjectModal from "../../Components/CreateSubjectModal/CreateSubjectModal";

const Subjects = () => {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadSubjects = async () => {
    try {
      setLoading(true);
      setError(null);

      const subjectsData = await fetchSubjects();
      setSubjects(subjectsData);
      message.success("Subjects loaded");
    } catch (error) {
      console.error(error);
      setError(error.message);
      message.error("Failed to load subjects");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSubjects();
  }, []);

  // >>> DELETE HANDLER
  const handleDelete = async (id) => {
    try {
      setLoading(true);
      await deleteSubject(id);
      message.success("Subject deleted");
      loadSubjects(); // Refresh list after deletion
    } catch (error) {
      console.error(error);
      message.error("Failed to delete subject");
    } finally {
      setLoading(false);
    }
  };

  // Pass delete handler to your column generator
  const columns = getSubjectTableColumns(handleDelete);

  return (
    <div className="student-admin-container">
      <div style={{ marginBottom: 16 }}>
        <Space>
          <Button type="primary" onClick={loadSubjects} loading={loading}>
            Refresh Data
          </Button>
          <CreateSubjectModal onSubjectCreated={loadSubjects} />
        </Space>
      </div>

      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={subjects}
          rowKey={(record) => record.id}
          locale={{
            emptyText: error ? "Error loading subjects" : "No subjects found",
          }}
        />
      </Spin>
    </div>
  );
};

export default Subjects;
